import * as React from 'react';

import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

const LayoutIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.XM}
      svgProps={{ viewBox: '0 0 20 20' }}
      {...props}
    >
      <path
        d="M15.4825 1.77637H4.51749C3.79046 1.77637 3.09322 2.06518 2.57914 2.57926C2.06505 3.09334 1.77625 3.79059 1.77625 4.51761V15.4826C1.77625 16.2096 2.06505 16.9068 2.57914 17.4209C3.09322 17.935 3.79046 18.2238 4.51749 18.2238H15.4825C16.2095 18.2238 16.9067 17.935 17.4208 17.4209C17.9349 16.9068 18.2237 16.2096 18.2237 15.4826V4.51761C18.2237 3.79059 17.9349 3.09334 17.4208 2.57926C16.9067 2.06518 16.2095 1.77637 15.4825 1.77637ZM4.51749 3.60386H15.4825C15.7248 3.60386 15.9572 3.70013 16.1286 3.87149C16.2999 4.04285 16.3962 4.27527 16.3962 4.51761V6.3451H3.60374V4.51761C3.60374 4.27527 3.70001 4.04285 3.87137 3.87149C4.04273 3.70013 4.27515 3.60386 4.51749 3.60386ZM3.60374 15.4826V8.1726H9.08622V16.3963H4.51749C4.27515 16.3963 4.04273 16.3001 3.87137 16.1287C3.70001 15.9573 3.60374 15.7249 3.60374 15.4826ZM15.4825 16.3963H10.9137V8.1726H16.3962V15.4826C16.3962 15.7249 16.2999 15.9573 16.1286 16.1287C15.9572 16.3001 15.7248 16.3963 15.4825 16.3963Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LayoutIcon;
